export default __webpack_public_path__ + "static/afterall-serif-regular-woff-0eb965819787628fad10dc578f4d8007.woff";